import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ActionBar = ({ 
  onDownload, 
  onRetry, 
  onRetryWithCorrection,
  onRefresh,
  selectedCount,
  hasListener,
  hasOldMessages,
  canDownload,
  canRetry,
}) => {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const resetFilePicker = () => {
    setSelectedFile(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleRetryWithCorrection = async () => {
    const retryResults = await onRetryWithCorrection(selectedFile);
    const allSucceeded = Array.isArray(retryResults)
      && retryResults.length > 0
      && retryResults.every(result => result.success);

    if (allSucceeded) {
      resetFilePicker();
    }
  };

  return (
    <div className="action-bar">
      <div className="action-buttons">
        <button
          className="btn btn-secondary"
          onClick={onRefresh}
          title={t('messageDownload.refreshWithFilters')}
        >
          {t('common.refresh')}
        </button>
        
        {canDownload && (
          <button
            className="btn btn-primary"
            onClick={onDownload}
            disabled={selectedCount === 0 || hasOldMessages}
            style={hasOldMessages ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            title={hasOldMessages ? t('messageDownload.downloadNotPossibleOld') : ''}
          >
            {t('common.download')} {selectedCount > 0 && `(${selectedCount})`}
          </button>
        )}
        
        {hasOldMessages && selectedCount > 0 && canDownload && (
          <div className="warning-message" style={{ color: '#d97706', fontSize: '14px', marginTop: '8px' }}>
            {t('messageDownload.warningDownloadOld')}
          </div>
        )}
        
        {hasListener && canRetry && (
          <>
            <button
              className="btn btn-success"
              onClick={() => onRetry()}
              disabled={selectedCount === 0 || hasOldMessages}
              style={hasOldMessages ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
              title={hasOldMessages ? t('messageDownload.retryNotPossibleOld') : ''}
            >
              {t('messageDownload.retry')} {selectedCount > 0 && `(${selectedCount})`}
            </button>
            
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              className="file-input"
            />
            
            <button
              className="btn btn-warning"
              onClick={handleRetryWithCorrection}
              disabled={!selectedFile || hasOldMessages}
              style={hasOldMessages ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
              title={hasOldMessages ? t('messageDownload.retryWithCorrectionNotPossibleOld') : ''}
            >
              {t('messageDownload.retryWithCorrection')}
            </button>
          </>
        )}
        
        {hasOldMessages && selectedCount > 0 && hasListener && canRetry && (
          <div className="warning-message" style={{ color: '#d97706', fontSize: '14px', marginTop: '8px' }}>
            {t('messageDownload.warningRetryOld')}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionBar;